import React from 'react';
import weights from '../assets/premarket/pinngro-weights.png';
import stretch from '../assets/premarket/pinngro-stretch.png';
import jog from '../assets/premarket/pinngro-jog.png';
import chart from '../assets/premarket/pinngro-chart.png';
import weightsMomentum from '../assets/premarket/pinngro-weights-momentum.png';
import stretchMomentum from '../assets/premarket/pinngro-stretch-momentum.png';
import jogMomentum from '../assets/premarket/pinngro-jog-momentum.png';
import chartMomentum from '../assets/premarket/pinngro-chart-momentum.png';
import weightsReversion from '../assets/premarket/pinngro-weights-reversion.png';
import stretchReversion from '../assets/premarket/pinngro-stretch-reversion.png';
import jogReversion from '../assets/premarket/pinngro-jog-reversion.png';
import chartReversion from '../assets/premarket/pinngro-chart-reversion.png';
import weightsCrossover from '../assets/premarket/pinngro-weights-crossover.png';
import stretchCrossover from '../assets/premarket/pinngro-stretch-crossover.png';
import jogCrossover from '../assets/premarket/pinngro-jog-crossover.png';
import chartCrossover from '../assets/premarket/pinngro-chart-crossover.png';
import weightsBreakdown from '../assets/premarket/pinngro-weights-breakdown.png';
import stretchBreakdown from '../assets/premarket/pinngro-stretch-breakdown.png';
import jogBreakdown from '../assets/premarket/pinngro-jog-breakdown.png';
import chartBreakdown from '../assets/premarket/pinngro-chart-breakdown.png';
import weightsExperiment from '../assets/premarket/pinngro-weights-experiment.png';
import stretchExperiment from '../assets/premarket/pinngro-stretch-experiment.png';
import jogExperiment from '../assets/premarket/pinngro-jog-experiment.png';
import chartExperiment from '../assets/premarket/pinngro-chart-experiment.png';
import weightsClassic from '../assets/premarket/pinngro-weights-classic.png';
import stretchClassic from '../assets/premarket/pinngro-stretch-classic.png';
import jogClassic from '../assets/premarket/pinngro-jog-classic.png';
import chartClassic from '../assets/premarket/pinngro-chart-classic.png';
import weightsCustom from '../assets/premarket/pinngro-weights-custom.png';
import stretchCustom from '../assets/premarket/pinngro-stretch-custom.png';
import jogCustom from '../assets/premarket/pinngro-jog-custom.png';
import chartCustom from '../assets/premarket/pinngro-chart-custom.png';

const illustrations = {
  trend: { weights, stretch, jog, charts: chart },
  momentum: { weights: weightsMomentum, stretch: stretchMomentum, jog: jogMomentum, charts: chartMomentum },
  reversion: { weights: weightsReversion, stretch: stretchReversion, jog: jogReversion, charts: chartReversion },
  crossover: { weights: weightsCrossover, stretch: stretchCrossover, jog: jogCrossover, charts: chartCrossover },
  breakdown: { weights: weightsBreakdown, stretch: stretchBreakdown, jog: jogBreakdown, charts: chartBreakdown },
  experiment: { weights: weightsExperiment, stretch: stretchExperiment, jog: jogExperiment, charts: chartExperiment },
  classic: { weights: weightsClassic, stretch: stretchClassic, jog: jogClassic, charts: chartClassic },
  custom: { weights: weightsCustom, stretch: stretchCustom, jog: jogCustom, charts: chartCustom },
};

// BotPresence supplies the existing strategy-family identity and authoritative activity.
// Artwork is decorative; operational status remains in BotLiveActivity.
export default function PremarketMascot({ activity, family }) {
  const identity = Object.hasOwn(illustrations, family) ? family : 'custom';
  const pose = Object.hasOwn(illustrations[identity], activity) ? activity : 'stretch';
  return <img
    className="premarket-mascot"
    src={illustrations[identity][pose]}
    width="300"
    height="218"
    alt=""
    draggable="false"
    decoding="async"
  />;
}
